import { Link, useLocation } from "react-router-dom";
import { Phone } from "lucide-react";
import { PHONE_TEL } from "../../data/site";

export const MobileCta = () => {
    const { pathname } = useLocation();
    if (pathname === "/termin") return null;

    return (
        <div
            data-testid="mobile-cta-bar"
            className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-2 md:hidden"
        >
            <a
                href={PHONE_TEL}
                data-testid="mobile-call-cta"
                className="flex items-center justify-center gap-2 border-t border-white/10 bg-[#0a0a0b]/95 py-4 text-[11px] font-semibold tracking-[0.2em] text-bone backdrop-blur-md"
            >
                <Phone size={14} strokeWidth={1.75} /> POZOVI
            </a>
            <Link
                to="/termin"
                data-testid="mobile-book-cta"
                className="flex items-center justify-center bg-bone py-4 text-[11px] font-semibold tracking-[0.2em] text-[#0a0a0b]"
            >
                ZAKAŽI TERMIN
            </Link>
        </div>
    );
};
